/**
 * --------------------------------------------------------
 * Imports
 * --------------------------------------------------------
 */

 require("typeface-rubik");

 import Alpine from 'alpinejs'
 import intersect from '@alpinejs/intersect'
 import Swiper, { Autoplay, EffectCoverflow, Navigation } from 'swiper';
 import Toastify from 'toastify-js'
 import "toastify-js/src/toastify.css"
 
 // deal with anchors
 window.onload = function () {
     if (window.location.hash) {
         setTimeout(function () {
             document.getElementById(window.location.hash.substring(1)).scrollIntoView(true);
         }, 100);
     }
 }
 
 // deal with form clicks
 document.body.addEventListener("click", function (e) {
     if (e.target &&
         e.target.classList.contains("go-form")) {
         document.getElementById('form').scrollIntoView(true);
     }
 });
 
 /**
  * --------------------------------------------------------
  * Alpine
  * --------------------------------------------------------
  */
 
 Alpine.plugin(intersect)
 window.Alpine = Alpine
 
 document.addEventListener('alpine:init', () => {
     Alpine.data('player', () => ({
         playing: false,
         togglePlay() {
             if (this.playing) {
                 this.stopAll();
             } else {
                 this.$refs.jingle.play()
             }
             this.playing = !this.playing;
         },
         stopAll() {
             this.$refs.jingle.pause()
             this.$refs.jingle.currentTime = 0;
             this.$refs.jingle_jazz.pause()
             this.$refs.jingle_jazz.currentTime = 0;
             this.$refs.jingle_pop.pause()
             this.$refs.jingle_pop.currentTime = 0;
             this.$refs.jingle_rock.pause()
             this.$refs.jingle_rock.currentTime = 0;
             this.$refs.jingle_trap.pause()
             this.$refs.jingle_trap.currentTime = 0;
         },
         init: function () {
             document.addEventListener("play-jazz", e => this.playJazz(e), false);
             document.addEventListener("play-pop", e => this.playPop(e), false);
             document.addEventListener("play-rock", e => this.playRock(e), false);
             document.addEventListener("play-trap", e => this.playTrap(e), false);
         },
         playJazz() {
             document.getElementById('familiares').scrollIntoView(true);
             if (this.playing) {
                 this.stopAll();
                 this.$refs.jingle_jazz.play()
             }
         },
         playPop() {
             document.getElementById('citadinos').scrollIntoView(true);
             if (this.playing) {
                 this.stopAll();
                 this.$refs.jingle_pop.play()
             }
         },
         playRock() {
             document.getElementById('suvs').scrollIntoView(true);
             if (this.playing) {
                 this.stopAll();
                 this.$refs.jingle_rock.play()
             }
         },
         playTrap() {
             document.getElementById('eletricos').scrollIntoView(true);
             if (this.playing) {
                 this.stopAll();
                 this.$refs.jingle_trap.play()
             }
         }
     }))
     Alpine.data('brands', () => ({
         swiper: {},
         init() {
             this.swiper = new Swiper('.swiper-brands', {
                 modules: [Autoplay],
                 loop: true,
                 autoplay: {
                     delay: 2000,
                     disableOnInteraction: false,
                 },
                 breakpoints: {
                     320: {
                         slidesPerView: 2,
                         spaceBetween: 20
                     },
                     480: {
                         slidesPerView: 3,
                         spaceBetween: 30
                     },
                     640: {
                         slidesPerView: 4,
                         spaceBetween: 50
                     },
                     900: {
                         slidesPerView: 5,
                         spaceBetween: 50
                     }
                 }
             });
         }
     }))
     const marcacaoDefault = {
         presencial: true,
         marca: "",
         distrito: "",
         local: "",
         data: "",
         hora: "",
     }
     Alpine.data('form', () => ({
         swiper: {},
         step: 1,
         submitting: false,
         error: false,
         datas: [
             {
                 label: 'Qua, 14 dezembro',
                 value: '2022-12-14'
             },
             {
                 label: 'Qui, 15 dezembro',
                 value: '2022-12-15'
             },
             {
                 label: 'Sex, 16 dezembro',
                 value: '2022-12-16'
             },
             {
                 label: 'Sáb, 17 dezembro',
                 value: '2022-12-17'
             }
         ],
         marcas: [],
         localidades: [],
         locais: [],
         horas: [],
         marcacoes: [{ ...marcacaoDefault }, 'nova'],
         cliente_nome: '',
         cliente_email: '',
         cliente_contacto: '',
         cliente_aceitou_termos: false,
         cliente_aceitou_tratamento_dados: false,
         init() {
             document.addEventListener("reset-marcacao", e => this.resetMarcacao(e), false);
             this.getMarcas()
             this.getLocais()
             this.swiper = new Swiper('.swiper-form', {
                 modules: [EffectCoverflow, Navigation],
                 init: false,
                 grabCursor: false,
                 centeredSlides: true,
                 slidesPerView: 'auto',
                 effect: "coverflow",
                 // allowTouchMove: false,
                 coverflowEffect: {
                     rotate: 0,
                     stretch: 0,
                     depth: 400,
                     modifier: 1,
                     slideShadows: false,
                 },
                 navigation: {
                     nextEl: ".swiper-button-next",
                     prevEl: ".swiper-button-prev",
                 },
             });
             this.$nextTick(() => {
                 this.updateSwiper()
             })
         },
         async getMarcas() {
             const response = await fetch('https://api.caetanocarmarket.pt/api/lp/options/brands');
             const names = await response.json();
             this.marcas = names
         },
         async getLocais() {
             const response = await fetch('https://api.caetanocarmarket.pt/api/lp/options/places');
             const names = await response.json();
             this.locais = names
             this.locais.map((l) => {
                 if (!this.localidades.includes(l.distrito)) {
                     this.localidades.push(l.distrito)
                 }
             })
             this.localidades.sort()
         },
         async getHoras(local, data, index) {
             const response = await fetch('https://api.caetanocarmarket.pt/api/lp/checkAvail?local=' + local + '&data=' + data)
             const horas = await response.json()
             this.horas[index] = horas
         },
         updateHoras(index) {
             this.$nextTick(() => {
                 this.getHoras(this.marcacoes[index].local, this.marcacoes[index].data, index)
             })
         },
         resetMarcacao(e) {
             if (e.detail.distrito) this.marcacoes[e.detail.index].distrito = ""
             if (e.detail.local) this.marcacoes[e.detail.index].local = ""
         },
         filterMarcas(index) {
             try {
                 return this.marcas
                 // desactivado temporáriamente
                 // para o caso de querermos filtrar as marcas com base nas outras opçoes.
                 return this.marcacoes[index].distrito
                     ? this.marcas.filter((m) => m.distritos.includes(this.marcacoes[index].distrito))
                     : this.marcas
             } catch (error) {
                 return this.marcas
             }
         },
         filterDistritos(index) {
             try {
                 return this.marcacoes[index].marca
                     ? this.marcas.find((m) => m.value === this.marcacoes[index].marca).distritos
                     : []
             } catch (error) {
                 return []
             }
         },
         filterConcessionarios(index) {
             try {
                 return this.marcacoes[index].distrito && this.marcacoes[index].marca
                     ? this.locais.filter((l) =>
                         l.distrito === this.marcacoes[index].distrito && l.brands.includes(this.marcacoes[index].marca)
                     )
                     : []
             } catch (error) {
                 return []
             }
         },
         updateSwiper(index = null) {
             this.swiper.init();
             this.swiper.update()
             this.swiper.slideTo(index || 0)
         },
         add() {
             this.marcacoes.splice(this.marcacoes.length - 1, 0, { ...marcacaoDefault })
             this.$nextTick(() => {
                 this.updateSwiper(this.marcacoes.length - 2)
             })
         },
         remove(index) {
             this.marcacoes.splice(index, 1)
             this.$nextTick(() => {
                 this.updateSwiper(index)
             })
         },
         reset(index) {
             this.marcacoes[index] = { ...marcacaoDefault }
             this.$nextTick(() => {
                 this.updateSwiper(index)
             })
         },
         setPresencial(index, value) {
             this.marcacoes[index].presencial = value
         },
         resetForm() {
             this.cliente_nome = ""
             this.cliente_email = ""
             this.cliente_contacto = ""
             this.cliente_aceitou_termos = false
             this.cliente_aceitou_tratamento_dados = false
             this.marcacoes = [{ ...marcacaoDefault }, 'nova']
             this.updateSwiper(0)
         },
         submit() {
             const urlParams = new URLSearchParams(window.location.search);
 
             const dados = {
                 cliente_nome: this.cliente_nome,
                 cliente_email: this.cliente_email,
                 cliente_contacto: this.cliente_contacto,
                 cliente_aceitou_termos: this.cliente_aceitou_termos,
                 cliente_aceitou_tratamento_dados: this.cliente_aceitou_tratamento_dados,
                 utm_source: urlParams.get('utm_source'),
                 utm_medium: urlParams.get('utm_medium'),
                 utm_content: urlParams.get('utm_content'),
                 utm_campaign: urlParams.get('utm_campaign'),
                 utm_term: urlParams.get('utm_term'),
                 marcacoes: this.marcacoes.filter((m) => m !== 'nova')
             }
 
             this.error = false;
             switch (this.step) {
                 case 1:
                     this.submitting = false
                     dados.marcacoes.map((m) => { m.tipo = m.presencial ? 'Visita Presencial' : 'Vídeo Conferência' })
                     dados.marcacoes.map((m) => { if (!m.hora) this.error = "Hora obrigatório nas marcações." })
                     dados.marcacoes.map((m) => { if (!m.data) this.error = "Dia obrigatório nas marcações." })
                     dados.marcacoes.map((m) => { if (!m.local) this.error = "Concessionário obrigatório nas marcações." })
                     dados.marcacoes.map((m) => { if (!m.distrito) this.error = "Distrito obrigatório nas marcações." })
                     dados.marcacoes.map((m) => { if (!m.marca) this.error = "Marca obrigatória nas marcações." })
                     if (this.error) {
                         Toastify({
                             text: this.error,
                             duration: 3000,
                             gravity: "bottom",
                             position: "center",
                             stopOnFocus: false,
                             style: {
                                 background: "#FF0000",
 
                             },
                             onClick: function () { }
                         }).showToast();
                     } else {
                         this.step = 2;
                         document.getElementById('topForm').scrollIntoView(true);
                     }
                     break;
                 case 2:
                     this.submitting = false
                     var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                     if (!dados.cliente_aceitou_termos) this.error = "Deve aceitar a nossa Política de Privacidade."
                     if (!dados.cliente_contacto) this.error = "O campo Contacto é obrigatório."
                     if (!dados.cliente_email || !dados.cliente_email.match(validRegex)) this.error = "O campo Email é obrigatório e deve conter um endereço de email válido."
                     if (!dados.cliente_nome) this.error = "O campo Nome é obrigatório."
                     if (this.error) {
                         Toastify({
                             text: this.error,
                             duration: 3000,
                             gravity: "bottom",
                             position: "center",
                             stopOnFocus: false,
                             style: {
                                 background: "#FF0000",
 
                             },
                             onClick: function () { }
                         }).showToast();
                     } else {
                         if (!this.submitting) {
                             this.submitting = true
                             fetch('https://api.caetanocarmarket.pt/api/lp/form/ccm2022', {
                                 method: "POST",
                                 headers: {
                                     "Content-Type": "application/json",
                                     Accept: "application/json",
                                 },
                                 body: JSON.stringify(dados),
                             })
                                 .then(() => {
                                     fbq("track", "Schedule");
                                     gtag("event", "submit", {
                                         event_category: "form_appointment",
                                         value: "submit",
                                         event_label: "CCM Form submitted",
                                     });
                                     this.resetForm();
                                     this.step = 3;
                                     this.submitting = false
                                     document.getElementById('topForm').scrollIntoView(true);
                                 })
                                 .catch(() => {
                                     this.submitting = false
                                     Toastify({
                                         text: "Ocorreu um erro ao tentar submeter as marcações. Por favor, tente novamente mais tarde.",
                                         duration: 3000,
                                         gravity: "bottom",
                                         position: "center",
                                         stopOnFocus: false,
                                         style: {
                                             background: "#FF0000",
 
                                         },
                                         onClick: function () { }
                                     }).showToast();
                                 });
                         }
 
                     }
                     break;
                 case 3:
                     break;
             }
         },
     }))
 })
 
 
 Alpine.start()
 
 console.log('crafted by: provider.pt | web artisans')